import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ANT_ICONS } from '../ant-svg-icons'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_I18N, vi_VN, en_US, NZ_ICONS, NZ_DATE_CONFIG, NzConfigService } from 'ng-zorro-antd';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import vi from '@angular/common/locales/vi';
import { SharedModule } from './shared.module';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { JwtInterceptor, ErrorInterceptor } from './helpers/';
import { ArticleService, AuthenticationService, UserService, NotificationService, LeaveService, CarService, WebSocketService, ChatService } from './services'
import { from } from 'rxjs';
import { DetailComponent } from './detail/detail.component';
import { WidgetComponent } from './layout/widget/widget.component';
import { PasswordComponent } from './password/password.component';
import { CalendarComponent } from './calendar/calendar.component';
import { TasksComponent } from './tasks/tasks.component';
import { SalaryComponent } from './salary/salary.component';
import { GroupsComponent } from './groups/groups.component';
import { DepartmentComponent } from './groups/department/department.component';
import { AnnouncementComponent } from './announcement/announcement.component';
import { MailComponent } from './mail/mail.component';
import { BirthdaysComponent } from './birthdays/birthdays.component';
import { LeaveComponent } from './leave/leave.component';
import { SearchComponent } from './search/search.component';
import { DocumentsComponent } from './documents/documents.component';
import { CarbookingComponent } from './carbooking/carbooking.component';
import { NewsComponent } from './news/news.component';
import { OrganizationComponent } from './groups/organization/organization.component';
import { EmployeeComponent } from './groups/employee/employee.component';
import { TimekeepingComponent } from './timekeeping/timekeeping.component';
import { WorkreportComponent } from './workreport/workreport.component';
import { AddWorkreportComponent } from './workreport/add/add.component';
import { EditWorkreportComponent } from './workreport/edit/edit.component';
import { WorkscheduleComponent } from './workschedule/workschedule.component';

registerLocaleData(vi);
const nzDateConfig = {
  vi_VN,
  ...{
    firstDayOfWeek: 1,
  }
  
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    DetailComponent,
    WidgetComponent,
    PasswordComponent,
    CalendarComponent,
    TasksComponent,
    SalaryComponent,
    GroupsComponent,
    AnnouncementComponent,
    DepartmentComponent,
    MailComponent,
    BirthdaysComponent,
    LeaveComponent,
    SearchComponent,
    DocumentsComponent,
    CarbookingComponent,
    NewsComponent,
    OrganizationComponent,
    EmployeeComponent,
    TimekeepingComponent,
    WorkreportComponent,
    AddWorkreportComponent,
    EditWorkreportComponent,
    WorkscheduleComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SharedModule,
    ReactiveFormsModule,
  ],
  providers: [
    { provide: NZ_I18N, useValue: vi_VN },
    { provide: NZ_DATE_CONFIG, useValue: nzDateConfig},
    { provide: NZ_ICONS, useValue: ANT_ICONS },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ArticleService, AuthenticationService, UserService, NotificationService, LeaveService, CarService, WebSocketService, ChatService
    ],
    
  bootstrap: [AppComponent]
})
export class AppModule { } 